export const windowHeight = function () {
  return document.documentElement.clientHeight;
}

export const getScroll = function () {
  return {
    x: window.pageXOffset || document.documentElement.scrollLeft,
    y: window.pageYOffset || document.documentElement.scrollTop,
  };
}

export const box = function ( el ) {
  return el.getBoundingClientRect();
}

export const offset = function ( el ) {
  const rect = box( el );
  const { x, y } = getScroll();
  return {
    top: rect.top + y,
    left: rect.left + x,
    box: rect,
  };
}

const floor = function ( ...nums ) {
  return nums.map( num => Math.floor( num ) );
}

export const passBy = function ( elm ) {
  const tgt = offset( elm );
  const { y: scrollY } = getScroll();
  const [ top, height ] = floor( tgt.top, tgt.box.height );
  return ( scrollY > top + height ) ? true : false;
}

export const stayOn = function ( elm, extra = 0 ) {
  const tgt = offset( elm );
  const { y: scrollY } = getScroll();
  const [ top, height, ex ] = floor( tgt.top, tgt.box.height, extra );
  return (
    scrollY + ex > top
    &&
    scrollY < top + height
  ) ? true : false;
}

export const fuckUpscroll = () => {
  let preScroll = getScroll().y;
  return () => {
    let bool = null;
    const curScroll = getScroll().y;
    const abs = Math.abs( curScroll - preScroll );
    bool = ( curScroll < preScroll ) ? true : false;
    preScroll = curScroll;
    return [ bool, abs ];
  }
}
